import heroBanner from "../../assets/images/pages/victim-impact.png";
import ShellCard from "../../components/ShellCard.jsx";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const VictimImpact = () => {
  useEffect(() => {
    document.title =
      "Victim Impact and Awareness Program - Metro Traffic School";
  }, []);

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">
                Victim Impact and Awareness Program
              </h1>
              <p className="banner-subheading">Metro Traffic School</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h3 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                      Course Details
                    </h3>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      As directed by the Court of Broward County and/or
                      Probation, you're hereby ordered to attend a Victim Impact
                      and Awareness Program (V.I.A.P.). Metro Traffic School is
                      proud to offer this impactful program at many convenient
                      locations throughout Broward.
                    </p>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      The D.U.I. Victim Impact and Awareness Program is an
                      awareness, prevention, healing, and educational program
                      designed to educate DUI offenders on the consequences of
                      drinking and driving.
                    </p>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      By hearing the stories of victims of DUI related offenses,
                      DUI offenders will gain awareness of the trauma, physical
                      pain, financial loss, anger, and distress that is commonly
                      experienced by the victims of DUI related offenses.
                    </p>
                  </div>

                  <div className="mb-4">
                    <p className="lh-lg fw-bold" style={{ color: "#fff" }}>
                      Our goal is for participants, upon completion, to:
                    </p>
                    <ul className="mb-4" style={{ color: "#fff" }}>
                      <li className="mb-2">
                        Be aware of the negative impact their actions may have
                        on others.
                      </li>
                      <li className="mb-2">
                        Accept responsibility for their past mistakes.
                      </li>
                      <li className="mb-2">
                        Make better and safer decisions. Primarily, refraining
                        from drinking and driving.
                      </li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      If you have not completed or enrolled for the DUI program,
                      it is important you do so now. To enroll for the DUI
                      program, just click on the{" "}
                      <a
                        href="https://classroom.metrotrafficschool.com/create-account/MjA=?_gl=1*1brs4tg*_gcl_au*MTU2NDc3NDA3Ni4xNzYzNTY2ODcw"
                        className="fw-bold text-decoration-none"
                        style={{ color: "var(--metro-yellow)" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Register now
                      </a>{" "}
                      button below. To enroll for the victim impact program
                      please call{" "}
                      <a
                        href="tel:954-922-3000"
                        className="fw-bold text-decoration-none"
                        style={{ color: "var(--metro-yellow)" }}
                      >
                        954-922-3000
                      </a>
                      .
                    </p>
                  </div>

                  <div className="row justify-content-center my-4">
                    {(() => {
                      const pkg = {
                        id: 1,
                        title: "Victim Impact & Awareness Program",
                        price: "$50",
                        description:
                          "Offered in multiple locations across Broward County.",
                        registerLink:
                          "http://classroom.metrotrafficschool.com/create-account/MjA=?_gl=1*1wpc2zz*_gcl_au*MTU2NDc3NDA3Ni4xNzYzNTY2ODcw",
                        isPackage: true,
                        columnClass: "col-12 col-md-6",
                      };
                      return (
                        <div key={pkg.id} className={pkg.columnClass}>
                          <div
                            className="h-100 p-4 text-center"
                            style={{
                              backgroundColor: "#252525",
                              borderRadius: "8px",
                              ...(pkg.isPackage && {
                                border: "2px solid var(--metro-yellow)",
                              }),
                            }}
                          >
                            <h3 className="text-white mb-3">{pkg.title}</h3>
                            <div className="mb-3">
                              <span
                                className="display-5 fw-bold"
                                style={{ color: "var(--metro-yellow)" }}
                              >
                                {pkg.price}
                              </span>
                            </div>
                            <p className="text-white mb-3">{pkg.description}</p>

                            <p className="fw-bold mt-3 text-warning">
                              Seating is limited.
                            </p>

                            <Link
                              to={pkg.registerLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary"
                            >
                              Register Now!
                            </Link>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-3 fs-5 text-white fw-bold">
              To reserve your seat, call{" "}
              <a
                href="tel:954-922-3000"
                className="fw-bold text-decoration-none"
                style={{ color: "var(--metro-yellow)" }}
              >
                (954) 922-3000
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default VictimImpact;
